import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Slide from '../Slide/Slide';

var formatSlideLayout = function formatSlideLayout(slideItems, itemsPerSlide) {
  var layout = slideItems.reduce(function (slideLayout, currentItem, currentIndex) {
    var slideIndex = itemsPerSlide === 1 ? currentIndex : Math.floor(currentIndex / itemsPerSlide);
    var currentSlide = slideLayout[slideIndex] || [];

    var currentLayout = _toConsumableArray(slideLayout);

    currentLayout[slideIndex] = [].concat(_toConsumableArray(currentSlide), [currentItem]);
    return currentLayout;
  }, []);
  return layout;
};

var generateSlides = function generateSlides(_ref) {
  var items = _ref.items,
      itemsPerSlide = _ref.itemsPerSlide,
      slidingFromDirection = _ref.slidingFromDirection,
      transitionSpeed = _ref.transitionSpeed,
      currentIndex = _ref.currentIndex,
      previouslyActiveIndex = _ref.previouslyActiveIndex,
      slideClass = _ref.slideClass,
      dataTest = _ref['data-test'];
  var layout = formatSlideLayout(items, itemsPerSlide);
  var slides = layout.map(function (content, layoutIndex) {
    var slideIndex = layoutIndex + 1;
    var isActive = slideIndex === currentIndex;
    var wasActive = slideIndex === previouslyActiveIndex;
    var tabIndex = isActive ? undefined : -1;
    var slideContent = content.map(function (item, itemIndex) {
      var Component = item.type;
      var ref = item.ref;
      var key = "".concat(slideIndex).concat(itemIndex);
      return /*#__PURE__*/React.createElement(Component, _extends({}, _objectSpread(_objectSpread({}, item.props), {}, {
        tabIndex: tabIndex,
        ref: ref
      }), {
        key: key,
        "data-test": "".concat(dataTest, "-slide-").concat(itemIndex)
      }));
    });
    return /*#__PURE__*/React.createElement(Slide, {
      key: slideIndex,
      tabIndex: tabIndex,
      slidingFromDirection: slidingFromDirection,
      transitionSpeed: transitionSpeed,
      slideClass: slideClass,
      isActive: isActive,
      wasActive: wasActive,
      "data-test": "".concat(dataTest, "-slide-").concat(slideIndex)
    }, slideContent);
  });
  return slides;
};

export default generateSlides;